<template>
  <v-autocomplete
    v-model="selectedEmpresas"
    :label="label"
    item-text="nome"
    item-value="cnpj"
    :prepend-icon="prependIcon"
    :items="getEmpresas"
    :dark="dark"
    :multiple="multiple"
    :disabled="disabled"
    :rules="validate ? [rules.required] : []"
    @change="onChanged()"
  >
    <template v-if="multiple" v-slot:prepend-item>
      <v-btn color="blue darken-2" text depressed @click="selectAll()">Marcar Todos</v-btn>&nbsp;
      <v-btn color="blue darken-2" text depressed @click="selectAll(false)">Desmarcar Todos</v-btn>

      <v-divider class="mt-2 mb-2"></v-divider>
    </template>

    <template v-slot:selection="{ item, index }">
      <v-chip v-if="index === 0">
        <span>{{ item.nome }}</span>
      </v-chip>
      <span v-if="index === 1" class="red--text caption">(+{{ selectedEmpresas.length - 1 }})</span>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapGetters } from "vuex";
import rules from "@/utils/rules";
import Empresa from "@/services/empresa";

export default {
  name: "SelectEmpresas",

  props: {
    label: {
      type: String,
      default: "Empresas"
    },

    multiple: {
      type: Boolean,
      default: false
    },

    dark: {
      type: Boolean,
      default: false
    },

    validate: {
      type: Boolean,
      default: true
    },

    disabled: {
      type: Boolean,
      default: false
    },

    prependIcon: String,

    empresasSelecionadas: [Array, String]
  },

  data() {
    return {
      rules: rules,
      selectedEmpresas: this.empresasSelecionadas
    };
  },

  computed: {
    ...mapGetters(["getEmpresas"])
  },

  methods: {
    selectAll(all = true) {
      if (all) {
        this.selectedEmpresas = this.getEmpresas.map(value => value.cnpj);
      } else {
        this.selectedEmpresas = [];
      }

      this.onChanged();
    },

    onChanged() {
      this.$emit("onChanged", this.selectedEmpresas);

      this.onEmpresas();
    },
    onEmpresas() {
      const listEmpresas = Array();
      this.getEmpresas.forEach(element => {
        listEmpresas.push({
          nome: element.nome,
          cnpj: element.cnpj
        });
      });

      this.$emit("onEmpresas", listEmpresas);
    }
  },

  watch: {
    empresasSelecionadas: {
      handler() {
        this.selectedEmpresas = this.empresasSelecionadas;
      },
      deep: true
    }
  }
};
</script>
